import React from 'react'
import { Route, Routes, useNavigate } from 'react-router-dom'
import { ClinicDashboard } from '../components/dashboards/ClinicDashboard';
import { AddClinic } from '../components/forms/AddClinic';
import { useLocation } from 'react-router-dom';
import { removeAccessToken, removeadminInfo } from '../lib/slices/authSlice';
import { useDispatch } from 'react-redux';

export const AdminHome = ({ adminInfo }) => {
    const navigate = useNavigate()
    const dispatch = useDispatch()
    const { pathname } = useLocation()

    const handleLogout = async () => {
        await dispatch(removeAccessToken())
        await dispatch(removeadminInfo())
        navigate('/login')
    }
    return (
        <main className='bg-[#f5f5f5] px-5  w-full flex  flex-auto'>
            <div className='w-[20%] flex flex-col justify-between py-16  items-center'>
                <div className='w-fit'>
                    <div className='rounded-full w-[100px] aspect-square border-blue-600 border-[4px] '>

                    </div>
                    Welcome Back,
                    <br />
                    {adminInfo?.adminEmployeeId}
                </div>
                {pathname === ('/admin' || '/admin/') ? <button onClick={() => navigate("add")} className='rounded-lg border-blue-500 border-[4px] px-9 py-2 hover:bg-blue-500 hover:text-white'>Add Clinic</button> : <button onClick={() => navigate("/admin")} className='rounded-lg border-blue-500 border-[4px] px-9 py-2 hover:bg-blue-500 hover:text-white'>Go Back</button>}
                <button onClick={() => handleLogout()} className=' text-white h-fit bg-[conic-gradient(at_bottom_right,_var(--tw-gradient-stops))] from-blue-900  to-blue-500 w-fit rounded-lg px-7 py-1 shadow-xl'>
                    Logout
                </button>
            </div>
            <div className='w-[80%] h-full'>
                <Routes>
                    <Route path="/" element={<ClinicDashboard adminInfo={adminInfo} />} />
                    <Route path="/add" element={<AddClinic />} />
                </Routes>
            </div>

        </main>
    )
}
